import { Flex, Typography } from 'antd';
import { memo } from 'react';

import styles from './styles.module.scss';

import type { ITrendingChartLegendProps } from './types';

const { Text } = Typography;

const TrendingChartLegend = memo(
  ({ series, legendFormatter }: ITrendingChartLegendProps) => (
    <Flex
      className={styles.legend}
      align="center"
      gap={16}
      wrap
      justify="center"
    >
      {series.map((item) => (
        <Flex key={item.id} align="center" gap={4}>
          <span
            className={styles['legend-swatch']}
            style={{ backgroundColor: item.color }}
            data-testid="legend-swatch"
          />
          <Text className={styles['legend-label']}>
            {legendFormatter ? legendFormatter(item.label) : item.label}
          </Text>
        </Flex>
      ))}
    </Flex>
  ),
);

TrendingChartLegend.displayName = 'TrendingChartLegend';

export default TrendingChartLegend;
